import React from 'react';
import { Button } from "@mui/material";

/**
 * 入力フォーム用の共通コンポーネント
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.id - selectとlabelを関連付けるID
 * @param {string} props.selectTitle - ラベル
 * @param {string|number} props.value - 入力値
 * @param {function} props.onChange - 入力値が変化したときに呼ばれる関数
 * @param {Array} props.options - セレクト内に表示する選択肢リスト
 * @param {boolean} [props.show=true] - 先頭に「選択してください」を表示するかどうか
 *
 */

const RegistarButtonLayout = ({
    buttonTitle,
    type,
    onClick
}) => {
  const buttonColor = type === "submit" ? "#32c86b" : "#a1a1a1" ;

  return (
    <>
    <Button
      variant="contained"
      type={type}
      onClick={onClick}
      sx={{
        color: "white",
        backgroundColor: buttonColor,
        width: "100%",
        height: "30px",
        marginBottom: "20px",
        padding: "10px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "15px",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "#45a049",
          border: "none",
          boxShadow: "none"
        }
        }}
    >
        {buttonTitle}
    </Button>

    </>
  );
};

export default RegistarButtonLayout;